export const viewBase64File = (base64String: string) => {
  if (!base64String) return
  if (base64String.startsWith('data:')) {
    const newWindow = window.open()
    if (newWindow) {
      newWindow.document.write(
        `<iframe src="${base64String}" width="100%" height="100%" style="border:none;"></iframe>`
      )
    }
    return
  }
  let mimeType = 'application/pdf'
  if (base64String[0] === '/') mimeType = 'image/jpeg'
  if (base64String[0] === 'i') mimeType = 'image/png'
  const dataUrl = `data:${mimeType};base64,${base64String}`

  const newWindow = window.open()
  if (newWindow) {
    newWindow.document.write(
      `<iframe src="${dataUrl}" width="100%" height="100%" style="border:none;"></iframe>`
    )
  } else {
    alert('Please allow popups to view the file.')
  }
}

export const downloadBase64File = (
  base64String: string,
  fileName = 'download'
) => {
  if (!base64String) return
  const mimeMatch = base64String.match(/^data:(.*?);base64,/)
  const mimeType = mimeMatch ? mimeMatch[1] : 'application/octet-stream'

  const extension = mimeType.split('/')[1] || 'bin'
  const cleanBase64 = base64String.replace(/^data:.*;base64,/, '')

  // Convert base64 → Blob
  const byteCharacters = atob(cleanBase64)
  const byteNumbers = new Array(byteCharacters.length)
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i)
  }
  const byteArray = new Uint8Array(byteNumbers)
  const blob = new Blob([byteArray], { type: mimeType })

  // Create object URL and trigger download
  const blobUrl = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = blobUrl
  link.download = `${fileName}.${extension}`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)

  setTimeout(() => URL.revokeObjectURL(blobUrl), 5000)
}
